<kendo-treelist
  #treeListView
  class="forecast-table"
  [data]="rootItemsList"
  [fetchChildren]="fetchChildrenCallback"
  [hasChildren]="hasChildren"
  [loading]="loading"
  [height]="gridHeight"
  [isExpanded]="isExpanded"
  [trackBy]="trackByFn"
  [sortable]="{ allowUnsort: true, mode: 'single' }"
  [resizable]="true"
  [reorderable]="true"
  [columnMenu]="true"
  [filterable]="'menu'"
  [rowClass]="getRowClass"
  [sort]="treeListSort"
  [filter]="treeListFilter"
  (expand)="onExpand($event)"
  (collapse)="onCollapse($event)"
  (sortChange)="onSortChange($event)"
  (filterChange)="onFilterChange($event)"
  (columnVisibilityChange)="onColumnVisibilityChange($event)"
  (columnLockedChange)="onColumnLockedChange($event)"
  (columnResize)="onColumnResize($event)"
  (columnReorder)="onColumnReorder($event)"
>
  <!-- Toolbar: parent projects controls (date range, filter actions, bulk actions) -->
  <ng-template kendoTreeListToolbarTemplate *ngIf="showToolbar">
    <div class="d-flex flex-column gap-4 w-100">
      <!-- Filter State Chip -->
      <div
        class="d-flex align-items-center ml-2"
        *ngIf="treeListFilter.filters.length"
      >
        <strong class="mr-2">Filter(s):</strong>
        <kendo-chip
          *ngFor="let filter of treeListFilter.filters; index as i"
          class="mr-2"
          themeColor="info"
          rounded="large"
          [label]="getExtraFilterChipLabel(filter)"
          [removable]="true"
          removeIcon="k-icon k-i-close"
          (remove)="deleteExtraFilter(i)"
        >
        </kendo-chip>
        <small class="text-primary cursor-pointer text-nowrap" (click)="clearAllFilter()"
          >Remove all filters
        </small>
      </div>

      <div class="d-flex justify-content-end align-items-center flex-wrap" style="gap: 12px">
        <ng-content select="[treelistAdditionalControl]"></ng-content>
        <button
          *ngIf="isFilter"
          class="k-button btn btn-sm btn-warning forecast-table__header__toolbar"
          (click)="clearAll()"
          title="Clear all sorts and filters"
        >
          Clear Filters
        </button>

        <div *ngIf="fullScreenIconIsVisible" class="align-self-end">
          <app-icon
            *ngIf="toogleFullScreenIsVisible"
            class="forecast-table__header__toolbar__full-screen cursor-pointer"
            [name]="isFullScreen ? 'minimize' : 'full-screen'"
            (click)="fullScreen()"
            role="button"
            aria-label="Toggle fullscreen">
          </app-icon>
        </div>
      </div>

    </div>
  </ng-template>


  <!-- Menu Column -->
  <ng-template kendoTreeListColumnMenuTemplate let-service="service">
    <kendo-treelist-columnmenu-sort
      #sortItem
      *ngIf="service.column.field && service.column.sortable"
      [data]="rootItemsList"
      [service]="service"
    >
    </kendo-treelist-columnmenu-sort>
    <kendo-treelist-columnmenu-chooser
      *ngIf="service.column.includeInChooser"
      [service]="service"
    >
    </kendo-treelist-columnmenu-chooser>
    <kendo-treelist-columnmenu-filter
      #filterItem
      *ngIf="service.column.field && service.column.filterable"
      [kendoTreeListColumnMenuItem]="filterItem"
      [service]="service"
    >
    </kendo-treelist-columnmenu-filter>
  </ng-template>

  <!-- Checkbox selection column -->
  <kendo-treelist-column
    *ngIf="showCheckboxColumn"
    [locked]="true"
    [resizable]="false"
    [reorderable]="false"
    [sortable]="false"
    [columnMenu]="false"
    [filterable]="false"
    [style]="{ width: '50px', 'text-align': 'center' }"
    [headerStyle]="{ width: '50px', 'text-align': 'center' }"
    [minResizableWidth]="50"
    [width]="50"
  >
    <ng-template kendoTreeListHeaderTemplate>
      <div
        [ngbTooltip]="checkboxTooltip"
        container="body"
        placement="top"
        style="display: inline-block"
      >
        <input
          class="k-checkbox"
          type="checkbox"
          [checked]="isSelectAll"
          (change)="onSelectAllChange($event.target['checked'])"
        />
      </div>
    </ng-template>
    <ng-template kendoTreeListCellTemplate let-dataItem let-level="level">
      <input
        *ngIf="dataItem.__type !== LOADING_ROW_TYPE"
        class="k-checkbox"
        type="checkbox"
        [checked]="isRowSelected(dataItem)"
        [disabled]="rowSelectionDisabled ? rowSelectionDisabled(dataItem, level) : false"
        (change)="onRowSelectChange(dataItem, $event.target['checked'])"
      />
    </ng-template>
  </kendo-treelist-column>

  <kendo-treelist-column
    *ngFor="let col of columnDefs; first as isFirst"
    [field]="col.field"
    [title]="col.title"
    [width]="col.width"
    [locked]="col.locked"
    [lockable]="col.lockable !== false"
    [hidden]="!col.visible"
    [expandable]="col.expandable"
    [sortable]="col.sortable"
    [filterable]="col.filterable"
    [filter]="col.filterType === 'select' ? 'text' : (col.filterType || 'text')"
    [includeInChooser]="col.hiddenInColumnChooser !== true"
    [columnMenu]="col.sortable || col.filterable || !col.hiddenInColumnChooser"
  >
    <ng-template kendoTreeListHeaderTemplate>
      <span
        class="treelist-col-header"
        [ngbTooltip]="col.richTooltip ? richTooltipTpl : col.headerTooltip"
        container="body"
        placement="top"
        (mouseenter)="onHeaderTooltipEnter(col)"
      >
        <span class="treelist-col-header__title">{{ col.title }}</span>
        <span
          *ngIf="col.lockable"
          class="pin-btn ml-1"
          [class.pin-btn--unlocked]="!col.locked"
          (click)="toggleColumnLock(col.field, $event)"
        >
          <app-icon name="tack" [size]="16" aria-label="Pin column"></app-icon>
        </span>
      </span>
    </ng-template>

    <ng-template
      kendoTreeListFilterMenuTemplate
      *ngIf="col.filterType === 'select' || col.filterType === 'date'"
      let-filter
      let-column="column"
      let-filterService="filterService"
    >
      <ng-container [ngSwitch]="col.filterType">
        <kendo-treelist-date-filter-menu
          *ngSwitchCase="'date'"
          [column]="column"
          [filter]="filter"
          [filterService]="filterService"
        ></kendo-treelist-date-filter-menu>

        <kendo-select-filter
          *ngSwitchCase="'select'"
          [filter]="filter"
          [data]="col.selectSource"
          [filterService]="filterService"
          [isMenu]="true"
          [field]="col.field"
          [multiple]="col.selectMultiple"
          textField="display"
          valueField="val"
        ></kendo-select-filter>
      </ng-container>
    </ng-template>

    <ng-template kendoTreeListCellTemplate let-dataItem let-level="level" let-columnIndex="columnIndex">
      <!-- ── Loading Row Box ────────────────────────────────────────── -->
      <ng-container *ngIf="dataItem.__type === LOADING_ROW_TYPE">
        <!-- Render the box in the SKU column (usually index 1 after checkbox) -->
        <ng-container *ngIf="columnIndex === 0 || (showCheckboxColumn && columnIndex === 1)">
          <div class="treelist-loading-box">
             <span class="k-icon k-i-loading"></span>
             <span class="treelist-loading-box__text">Loading...</span>
          </div>
        </ng-container>
      </ng-container>

      <!-- ── Normal data row ───────────────────────────────────────────── -->
      <ng-container *ngIf="dataItem.__type !== LOADING_ROW_TYPE">
        <!-- Option A: Custom Template supplied via TreelistColumnDef.cellTemplate -->
        <ng-container
          *ngIf="
            customCellTemplates.get(col.field) as customTemplate;
            else defaultCell
          "
        >
          <ng-container
            *ngTemplateOutlet="
              customTemplate;
              context: { $implicit: dataItem, column: col, level: level }
            "
          >
          </ng-container>
        </ng-container>

        <!-- Option B: Default Cell Types using ngSwitch -->
        <ng-template #defaultCell>
          <ng-container [ngSwitch]="col.cellType">
            <app-treelist-currency-cell
              *ngSwitchCase="'currency'"
              [value]="dataItem[col.field]"
              [currencyCode]="col.currencyCode"
            ></app-treelist-currency-cell>

            <app-treelist-date-cell
              *ngSwitchCase="'date'"
              [value]="dataItem[col.field]"
              [format]="col.dateFormat"
            ></app-treelist-date-cell>

            <app-treelist-checkbox-cell
              *ngSwitchCase="'checkbox'"
              [value]="dataItem[col.field]"
            ></app-treelist-checkbox-cell>

            <app-treelist-badge-cell
              *ngSwitchCase="'badge'"
              [value]="dataItem[col.field]"
              [valueMap]="col.valueMap"
            ></app-treelist-badge-cell>

            <app-treelist-toggle-cell
              *ngSwitchCase="'toggle'"
              [value]="dataItem[col.field]"
            ></app-treelist-toggle-cell>

            <app-treelist-text-cell
              *ngSwitchDefault
              [value]="dataItem[col.field]"
            ></app-treelist-text-cell>
          </ng-container>
        </ng-template>
      </ng-container>
    </ng-template>
  </kendo-treelist-column>
</kendo-treelist>

<app-treelist-pager
  [total]="totalRootCount"
  [skip]="skip"
  [pageSize]="pageSize"
  [pageSizes]="pageSizes"
  (pageChange)="onPageChange($event)"
></app-treelist-pager>

<ng-template #richTooltipTpl>
  <div *ngIf="activeRichTooltip as config" class="rich-tooltip p-1">
    <strong class="d-block mb-1">{{ config.header }}</strong>
    <hr class="my-1 border-secondary">
    <small class="d-block font-italic mb-2">{{ config.formula }}</small>
    <div *ngIf="config.exampleData as ex" class="rich-tooltip__example mt-1">
      <span class="text-success font-weight-bold">{{ ex.result }}</span>
      &nbsp;=&nbsp;
      <span class="text-warning">{{ ex.operand1 }}</span>
      &nbsp;{{ ex.operator }}&nbsp;
      <span class="text-warning">{{ ex.operand2 }}</span>
    </div>
  </div>
</ng-template>
